import { render, staticRenderFns } from "./InstanceName.vue?vue&type=template&id=707aa7e2&"
import script from "./InstanceName.vue?vue&type=script&lang=js&"
export * from "./InstanceName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('707aa7e2')) {
      api.createRecord('707aa7e2', component.options)
    } else {
      api.reload('707aa7e2', component.options)
    }
    module.hot.accept("./InstanceName.vue?vue&type=template&id=707aa7e2&", function () {
      api.rerender('707aa7e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/budget-control/instance/components/InstanceName.vue"
export default component.exports